import { CircleCheck } from "lucide-react";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

const labels: Record<string, string> = {
  en: "Active host", it: "Host attivo", es: "Anfitrión activo", pt: "Anfitrião ativo",
  de: "Aktiver Gastgeber", fr: "Hôte actif", nl: "Actieve verhuurder", da: "Aktiv vært",
  sv: "Aktiv värd", no: "Aktiv vert", cs: "Aktivní hostitel", pl: "Aktywny gospodarz", sk: "Aktívny hostiteľ",
};
/** Server-derived, BAC-only recognition. Never infer activity from Pro tier. */
export function ActiveHostBadge({ carId }: { carId: string | number }) {
  const { i18n } = useTranslation();
  const { data } = useQuery({
    queryKey: ["bac-host-activity", String(carId)],
    queryFn: async () => {
      const response = await fetch(`${import.meta.env.BASE_URL}api/cars/host-activity-status?ids=${encodeURIComponent(carId)}`);
      if (!response.ok) throw new Error(response.statusText || String(response.status));
      return await response.json() as Record<string, boolean>;
    },
    enabled: !!carId, staleTime: 30_000, refetchInterval: 60_000,
  });
  if (data?.[String(carId)] !== true) return null;
  const label = labels[i18n.language.split("-")[0]] ?? labels.en;
  return <span className="inline-flex shrink-0 items-center gap-1 rounded-full border border-emerald-700/20 bg-emerald-50 px-2 py-0.5 text-[10px] font-semibold text-emerald-800">
    <CircleCheck aria-hidden="true" className="h-3 w-3" />{label}
  </span>;
}
